import { post } from "./base";

export function formatTipoArticolo(tipo) {
  if (tipo === "merce") return "Merce";
  if (tipo === "campione") return "Campione";
  if (tipo === "materiale_pubblicitario") return "Mat. Pubblicitario";
  return tipo || "-";
}

export function formatMonthExpiry(value) {
  if (typeof value !== "string") return "-";

  const match = /^(\d{4})-(\d{2})(?:-(\d{2}))?$/.exec(value);
  if (!match) return "-";

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = match[3] === undefined ? null : Number(match[3]);
  if (year === 0 || month < 1 || month > 12) return "-";

  if (day !== null) {
    const isLeapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const daysInMonth = [31, isLeapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (day < 1 || day > daysInMonth[month - 1]) return "-";
  }

  return `${match[2]}/${match[1]}`;
}

export function getArticoliEvento(accessToken, filters = {}) {
  return post("articoli_evento/GetArticoliEvento", { jsonBody: { accessToken, ...filters } });
}

export function getArticoliEventoByRichiesta(accessToken, idRichiesta) {
  return post("articoli_evento/GetArticoliEventoByRichiesta", { jsonBody: { accessToken, idRichiesta } });
}

export function addArticoloEvento(accessToken, payload) {
  return post("articoli_evento/AddArticoloEvento", { jsonBody: { accessToken, ...payload } });
}

export function deleteArticoloEvento(accessToken, id) {
  return post("articoli_evento/DeleteArticoloEvento", { jsonBody: { accessToken, id } });
}
